import { QueryClient } from "@tanstack/react-query";

/**
 * App-wide singleton QueryClient.
 *
 * Extracted from App.tsx so non-React modules (e.g. userRoleCache) can
 * read/invalidate the same cache without re-implementing their own Maps.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});
